import React from "react";
import { Box, Button, HStack, Link, Text } from "components/ui";
import { ParagraphSmall, Typography } from "components/ui/Typography";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { useGetSitesQuery } from "store/abcoApi";
import { ArrowRight, MapPin } from "lucide-react-native";
import { useToken } from "@gluestack-style/react";
import Section from "components/general/Section";

const SiteListSection = () => {
	const isMobile = useIsMobile();
	const resolvedPrimarylight = useToken("colors", "primarylight");
	const { data: siteData } = useGetSitesQuery({ pageSize: 9 });
	return (
		<Box borderRadius={12} bg="$neutral35" my={16} mb={34} width="$full">
			<HStack marginBottom={16} alignItems="center" gap={12}>
				<MapPin size={24} color="black" />
				<Typography.H3 weight="bold">Sites</Typography.H3>
			</HStack>
			{siteData && siteData.list && siteData.list.length > 0 && (
				<>
					<Box flexDirection="row" flexWrap="wrap" gap={16} width="$full">
						{siteData &&
							siteData.list &&
							siteData.list.map((site) => (
								<Box key={site.id} style={{ width: isMobile ? "100%" : "32%" }}>
									<Link
										href={`/sites/${site.id}`}
										component={(hovered) => {
											return (
												<Box borderRadius={8} borderWidth={1} borderColor="#e1e9f0" bg={hovered ? "#E1E9F0" : "$basicwhite"} paddingHorizontal={18} paddingVertical={18}>
													<HStack gap={4} alignItems="center">
														<MapPin size={16} color={site.name ? resolvedPrimarylight : "#999999"} />
														<Text fontSize={16} flex={1}>
															{site.name || "Not available"}
														</Text>
														<ArrowRight size={16} color={resolvedPrimarylight} />
													</HStack>
												</Box>
											);
										}}
									></Link>
								</Box>
							))}
					</Box>
					<Box alignItems="flex-start" mt={24}>
						<Link href={"/sites"}>
							<Text
								// @ts-ignore
								style={{
									marginTop: 8,
									color: "#0066CC",
									fontWeight: "500",
									borderBottomWidth: 1,
									borderBottomColor: "#0066CC",
									width: "fit-content",
								}}
							>
								See More
							</Text>
						</Link>
						{/* <Button borderRadius={8} isLink href="/sites" variant="outline">
							<Typography.ParagraphSmall sx={{ color: "$primarylight" }}>See more</Typography.ParagraphSmall>
						</Button> */}
					</Box>
				</>
			)}

			{siteData?.list?.length === 0 && (
				<Section gap={24}>
					<Box flex={2} gap={12}>
						<Typography.H3>No sites found</Typography.H3>
						<Typography sx={{ lineHeight: 21 }}>This page keeps track of all your sites — acting as your team's site register.</Typography>
						<Typography sx={{ lineHeight: 21 }}>Right now, it's empty — once sites are added, everything will appear here automatically.</Typography>
					</Box>
					{/* <Box flex={1} width="$full">
						<Button isLink borderRadius={8} variant="primary-light" href="/admin/groups">
							<Text sx={{ color: "$basicwhite" }}>Add New Site</Text>
						</Button>
					</Box> */}
				</Section>
			)}
		</Box>
	);
};

export default SiteListSection;
